

import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

const UploadButtonForm = ({ fileId, fileNameId ,contentFieldId,accept }) => {
    const fileField = fileId ? fileId : "file";
    const fileNameField = fileNameId ? fileNameId : "fileName";
    const contentField = contentFieldId ? contentFieldId : 'contentType';
    // Create a reference to the hidden file input element
    const hiddenFileInput = React.useRef(null);
    const [ file, setFile ] = useState();
    const { setFieldValue } = useFormikContext();

    const [error, setError] = useState();
    // Programatically click the hidden file input element
    // when the Button component is clicked
    const handleClick = () => {
        hiddenFileInput.current.click();
    };
    // Call a function (passed as a prop from the parent component)
    // to handle the user-selected file 
    const handleChangeUpload =async event => {
        const blob = event.target.files[0];
      
        setFile(blob);
    };
    
  
  
    useEffect(() => {
        const blobToBase64 = (file) => {
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    const [content, data] = reader.result.split(',');
                    setFieldValue(fileField, data);
                    setFieldValue(contentField, content);
                    setFieldValue(fileNameField, file.name);
                }
                reader.onerror = error => setError(error);
                reader.readAsDataURL(file);
            }
        }
        blobToBase64(file)
    }, [file, contentField,fileField,fileNameField,setFieldValue]);
    return (
        <React.Fragment>
            <Button onClick={handleClick}>
                {file ? "Replace" : "Upload" }
            </Button>
            {error?<h5>Error Saving</h5>:null}
              
            <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChangeUpload}
                style={{ display: 'none' }}
                accept={accept}
            />
        </React.Fragment>
    );
}
export default UploadButtonForm;